<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
/* eslint-disable */
import Listar from "./Listar";

export default {
  name: "motoristas",
  data() {
    return {
      title: "Motoristas"
    };
  },
  components: {
    "page-listar": Listar
  },
  methods: {
    isIndexOnly() {
      return (
        this.$router.currentRoute.path === "/motoristas" ||
        this.$router.currentRoute.path === "/motoristas/"
      );
    }
  },
  mounted() {
    this.$parent.$data.title = this.title;
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/motorista/index.vue